import { useRef, useState } from "react";
import UploadFile from '../../UploadFile/UploadFile';
import Toast from '../../Shared/Toast/Toast';
import DeleteConfirmation from "../../Dialogs/DeleteConfirmation";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { apiBase } from '../../../utils/config';
import userImage from '../../../assets/images/Logo.svg';

export default function GraceMarksCard(props) {
    const fileUploadRef = useRef(null);
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };
    const handleDelete = () => {
        setIsDeleteConfirmation(true)
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={() => {
                    handleClose();
                    props.onProfileChange(props.student?.id, '', '');
                    if (fileUploadRef.current) {
                        fileUploadRef.current.clear();
                    }
                }}
            />
        </div>
    );

    const handleFileSelect = (e) => {
        const selectedFile = e.files[0];
        if (selectedFile) {
            const img = new Image();
            img.onload = () => {
                const aspectRatio = img.width / img.height;
                const expectedRatio = 3 / 4;
                const tolerance = 0.01;

                if (Math.abs(aspectRatio - expectedRatio) <= tolerance) {
                    const fileURL = URL.createObjectURL(selectedFile);
                    props.onProfileChange(props?.student?.id, selectedFile, fileURL);
                } else {
                    if (fileUploadRef.current) {
                        fileUploadRef.current.clear();
                    }
                    Toast.error({ message: 'The image must have a 3:4 aspect ratio.' });
                }
            };
            img.onerror = () => {
                if (fileUploadRef.current) {
                    fileUploadRef.current.clear();
                }
                Toast.error({ message: 'Error loading the image.' });
            };

            const reader = new FileReader();
            reader.onload = (event) => {
                img.src = event.target.result;
            };
            reader.readAsDataURL(selectedFile);
        }
    };

    return (
        <div className="p-4">
            <div className="flex items-center gap-4 p-4 border-b mb-4">
                <UploadFile label='' note='' preview={props?.student?.PreviewProfilePhotoUrl} original={props?.student?.ProfilePhotoUrl ? `${apiBase}/UserProfilePic/${props?.student?.ProfilePhotoUrl}` : userImage} uploadHandler={handleFileSelect} uploadRef={fileUploadRef} handleDelete={handleDelete} isEditAllow={true} aspectRatio={3 / 4} />
                <div>
                    <h3 className="text-lg font-semibold">{props?.student?.Name || "Unknown Student"}</h3>
                    <p className="text-gray-500">Roll No: {props?.student?.RollNo || "N/A"}</p>
                </div>
            </div>
            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
        </div>
    );
}
